import { connect } from 'react-redux';
import StoreSelector from '../../../components/store/StoreSelector';
import { loadingStores, currentChain, currentStoreName } from 'core/selectors';

export default connect(
  state => ({
    loading: loadingStores(state),
    currentChain: currentChain(state),
    currentStoreName: currentStoreName(state),
  }),
  {},
)(StoreSelector);
